/**
 * 인증 초기화 로직
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { resolveStorageKeys } from '../storage-keys';
/**
 * 인증 초기화 함수 생성
 */ export var createAuthInitializer = function(config) {
    return /*#__PURE__*/ _async_to_generator(function() {
        var initializationCompleted, completeInitialization, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    initializationCompleted = false;
                    completeInitialization = function() {
                        var authData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        if (!initializationCompleted) {
                            initializationCompleted = true;
                            config.setAuthState(function(prev) {
                                return _object_spread_props(_object_spread({}, prev, authData), {
                                    isLoading: false,
                                    isInitialized: true
                                });
                            });
                            console.log('[AuthInitializer] 초기화 완료:', authData);
                        }
                    };
                    console.log('[AuthInitializer] 인증 초기화 시작', {
                        isVSCodeEnv: config.isVSCodeEnv,
                        hasIdeMessenger: !!config.ideMessengerInstance
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    config.setAuthState(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            isLoading: true,
                            isInitialized: false
                        });
                    });
                    if (!(config.isVSCodeEnv && config.ideMessengerInstance)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        initializeVSCodeAuth(config, completeInitialization)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    if (!!config.isVSCodeEnv) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        initializeWebAuth(config, completeInitialization)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    console.log('[AuthInitializer] 기타 환경 - 로딩 종료');
                    completeInitialization();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    error = _state.sent();
                    console.error('[AuthInitializer] 초기화 중 오류:', error);
                    completeInitialization({
                        error: '인증 초기화 실패'
                    });
                    return [
                        3,
                        8
                    ];
                case 8:
                    // 안전장치: 5초 후 강제로 로딩 종료
                    setTimeout(function() {
                        if (!initializationCompleted) {
                            console.warn('[AuthInitializer] 초기화 타임아웃 - 강제로 로딩 종료');
                            completeInitialization({
                                error: '초기화 타임아웃'
                            });
                        }
                    }, 5000);
                    return [
                        2
                    ];
            }
        });
    });
};
function initializeVSCodeAuth(config, completeInitialization) {
    return _initializeVSCodeAuth.apply(this, arguments);
}
function _initializeVSCodeAuth() {
    _initializeVSCodeAuth = /**
 * VSCode 환경 초기화
 */ _async_to_generator(function(config, completeInitialization) {
        var authResponse, vscodeError;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('[AuthInitializer] VSCode 환경 - 세션 정보 확인');
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        config.ideMessengerInstance.request('getControlPlaneSessionInfo', {
                            silent: true
                        })
                    ];
                case 2:
                    authResponse = _state.sent();
                    if (!(authResponse === null || authResponse === void 0 ? void 0 : authResponse.accessToken)) return [
                        3,
                        4
                    ];
                    console.log('[AuthInitializer] VSCode 토큰 발견');
                    return [
                        4,
                        config.fetchUserProfile(authResponse.accessToken)
                    ];
                case 3:
                    _state.sent();
                    completeInitialization();
                    return [
                        3,
                        5
                    ];
                case 4:
                    console.log('[AuthInitializer] VSCode 토큰 없음');
                    completeInitialization();
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    vscodeError = _state.sent();
                    console.warn('[AuthInitializer] VSCode 세션 정보 가져오기 실패:', vscodeError);
                    completeInitialization();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _initializeVSCodeAuth.apply(this, arguments);
}
function initializeWebAuth(config, completeInitialization) {
    return _initializeWebAuth.apply(this, arguments);
}
function _initializeWebAuth() {
    _initializeWebAuth = /**
 * 웹 환경 초기화
 */ _async_to_generator(function(config, completeInitialization) {
        var storageKeys, storedToken, storedUser, storedRefreshToken, user;
        return _ts_generator(this, function(_state) {
            console.log('[AuthInitializer] 웹 환경 초기화 시작');
            storageKeys = resolveStorageKeys(config.storageKeys);
            storedToken = localStorage.getItem(storageKeys.tokenKey);
            storedUser = localStorage.getItem(storageKeys.userKey);
            storedRefreshToken = localStorage.getItem(storageKeys.refreshTokenKey);
            console.log('[AuthInitializer] 저장된 토큰 및 사용자 확인:', {
                hasToken: !!storedToken,
                hasUser: !!storedUser,
                hasRefreshToken: !!storedRefreshToken,
                tokenLength: (storedToken === null || storedToken === void 0 ? void 0 : storedToken.length) || 0
            });
            if (storedToken && storedUser) {
                try {
                    user = JSON.parse(storedUser);
                    // 토큰 설정
                    config.tokenManager.setToken(storedToken);
                    config.apiService.setToken(storedToken);
                    // 저장된 사용자 정보로 상태 복원 (refreshToken 포함)
                    config.setAuthState({
                        user: user,
                        token: storedToken,
                        refreshToken: storedRefreshToken || null,
                        isAuthenticated: true,
                        isLoading: false,
                        isInitialized: true,
                        error: null
                    });
                    completeInitialization({
                        user: user,
                        token: storedToken,
                        refreshToken: storedRefreshToken || null,
                        isAuthenticated: true
                    });
                } catch (error) {
                    console.error('[AuthInitializer] 저장된 사용자 정보 파싱 실패:', error);
                    localStorage.removeItem(storageKeys.userKey);
                    localStorage.removeItem(storageKeys.tokenKey);
                    localStorage.removeItem(storageKeys.refreshTokenKey);
                    localStorage.removeItem(storageKeys.idTokenKey);
                    completeInitialization();
                }
            } else {
                console.log('[AuthInitializer] 웹 환경 - 저장된 토큰 없음');
                completeInitialization();
            }
            return [
                2
            ];
        });
    });
    return _initializeWebAuth.apply(this, arguments);
}
